<h1 mat-dialog-title>Privacy Policy </h1>
<div id="footer-pp-section-content" mat-dialog-content [innerHTML]="PrivacyPolicyHTML">
</div>
<div id="footer-pp-section-action" class="action-button-container" mat-dialog-actions align="end">
    <button id="footer-pp-button-close" mat-flat-button mat-dialog-close color="accent">Close</button>
    <button id="footer-pp-button-primary" mat-flat-button [color]="'primary'" (click)="OnClickLearnMore()">Learn More</button>
</div>
